var _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedicalExamYes(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 17535",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12998",
    d: "M7.11 5.493L4.34 2.72"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12999",
    d: "M2.66 4.4l2.767 2.773"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13000",
    d: "M8.7 3.907l-4.867 4.86"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13001",
    d: "M11.567 11.634L14 14.067"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13002",
    d: "M11.08 8.234l-.973.973"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13003",
    d: "M9.62 6.774l-.973.973"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13004",
    d: "M5.033 2.027L2 5.06"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13005",
    d: "M4.77 7.832l4.358 4.358a1.333 1.333 0 001.885 0l1.071-1.07a1.333 1.333 0 000-1.885L7.727 4.877"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13006",
    d: "M16 0H0v16h16z",
    fill: "none"
  })));
}
export default SvgMedicalExamYes;


//////////////////
// WEBPACK FOOTER
// ./src/icons/medicalExam-yes.svg
// module id = 467
// module chunks = 13